import { Flag } from "@/icons";
import { useTranslate } from "@/providers/context";

export const FlagCount = ({ value }: { value: number }) => {
  const { translate } = useTranslate();

  const label = translate(value === 1 ? "Report" : "Reports");

  return (
    <div className="flex items-center gap-[1px] text-flagged-item">
      <Flag className="h-3 w-3" />
      <span className="caption-medium">{`${value} ${label}`}</span>
    </div>
  );
};
